import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "32",
  height: "32",
  fill: "none",
  viewBox: "0 0 32 32"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      stroke: "#FF5100",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "1.5",
      d: "M24.158 9.823V6.118a1.235 1.235 0 0 0-1.235-1.235H6.87a2.47 2.47 0 0 0 0 4.94h18.524a1.235 1.235 0 0 1 1.235 1.234v4.94m0 0h-3.705a2.47 2.47 0 1 0 0 4.94h3.705a1.235 1.235 0 0 0 1.235-1.235v-2.47a1.235 1.235 0 0 0-1.235-1.235"
    }, null, -1),
    _createElementVNode("path", {
      stroke: "#FF5100",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "1.5",
      d: "M4.4 7.352V24.64a2.47 2.47 0 0 0 2.47 2.47h18.523a1.235 1.235 0 0 0 1.235-1.236v-4.94"
    }, null, -1)
  ]))]))
}
export default { render: render }